// extracted by mini-css-extract-plugin
export default {"checkoutPreview":"CheckoutPreview_checkoutPreview__eWiuf"};